<template>
  <div style="overflow: auto">
  <el-row>
  <el-col style="margin-left: 100px; margin-top: 30px" :span="17">
    <el-form ref="busData" :model="busData" :rules="rules">

      <el-form-item prop="name" label="客户名称：" label-width="100px">
        <el-input v-model="busData.name" placeholder="客户名称"></el-input>
      </el-form-item>

      <el-form-item label-width="100px" label="英文名：">
        <el-input v-model="busData.name_en" placeholder="英文名称"></el-input>
      </el-form-item>

      <el-form-item label-width="100px" label="地址：" prop="address">
        <el-input v-model="busData.address" placeholder="详细地址"></el-input>
      </el-form-item>

      <el-form-item label-width="100px" label="网址：">
        <el-input v-model="busData.website" placeholder="公司官网"></el-input>
      </el-form-item>

      <el-form-item label-width="100px" label="产品：">
        <el-input v-model="busData.productInfo" :rows="2" type="textarea" placeholder="产品介绍"></el-input>
      </el-form-item>

      <el-form-item label-width="100px" label="简介：">
        <el-input v-model="busData.abstracts_base_info" :rows="3"  type="textarea" placeholder="公司简介"></el-input>
      </el-form-item>
      <el-form-item label-width="100px" label="经营范围：">
        <el-input v-model="busData.business_scope" :rows="2" type="textarea" placeholder="经营范围"></el-input>
      </el-form-item>

      <el-form-item label-width="100px" label="系统现状：">
        <el-cascader :props="system" :options="systemList" style="width: 500px"
                     :show-all-levels="false" placeholder="请选择" v-model="busData.integrateSystems"
                     clearable filterable />
      </el-form-item>

      <el-form-item label-width="100px" label="已购套数：">
        <el-input-number v-model="busData.buyNumber" min="0" placeholder="已购套数"></el-input-number>
      </el-form-item>

      <el-form-item width="500px" label-width="100px" label="系统备注：">
        <el-input v-model="busData.systemRemark"  placeholder="系统备注"></el-input>
      </el-form-item>

      <el-form-item label-width="100px" label="注册地：">
        <el-cascader :props="props" v-model="busData.code" :options="catalogWithCity"  style="width: 400px"
                     placeholder="选择地区"
                     clearable filterable/>
      </el-form-item>

      <el-form-item label-width="100px" label="行业："  prop="industry">
        <el-select v-model="busData.industry" placeholder="行业类型" clearable>
          <el-option v-for="item in industryList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>

      </el-form-item>

      <el-form-item label-width="100px" label="归属：" prop="belong">
        <el-checkbox v-model="busData.belong"  style="margin-right: 40px;" label="卓盛客户"/>

      </el-form-item>
      <el-form-item label-width="100px" label="轮播图：" prop="imageIds">
        <kf-image-upload limit="9" v-model="busData.imageIds" @fileChange="setImageId"></kf-image-upload>
      </el-form-item>
      <el-form-item label-width="100px" label="备注：">第一张添加图为案例展示菜单首页展示图</el-form-item>
    </el-form>
  </el-col>
    <el-col style="margin-top: 30px; margin-left: 10px" :span="4">
      <el-button @click="getTycUrlInfo"  >获取信息</el-button>
    </el-col>
  </el-row>
  <el-button type="primary" style="width: 100px; margin-left: 50%; margin-bottom: 30px" @click="addCustomer()" >提交</el-button>
  </div>
</template>
<script>

import {Plus} from "@element-plus/icons-vue";

export default {
  name: "CaseAddCustomer",
  components: {Plus},
  inject: ['$fn'],

  data() {
    return {
      catalogWithCity: [],
      industryList:[],
      systemList:[],
      busData:{
        tycUrl:'',
        name:'',
        name_en:'',
        address:'',
        website:'',
        productInfo:'',
        abstracts_base_info:'',
        integrateSystems:[],
        buyNumber:0,
        business_scope:'',
        systemRemark:'',
        code:'',
        belong:false,
        industry:'',
        imageIds:[],
      },
      rules: {
        name: [{required: true, message: '请输入客户名称', trigger: 'blur'}],
        /*EnglishName: [{required: true, message: '请输入客户英文名称', trigger: 'blur'}],*/
        address: [{required: true, message: '请输入客户地址', trigger: 'blur'}],
        industry: [{required: true, message: '请选择行业', trigger: 'change'}],
        belong: [{required: true, message: '请选择客户归属', trigger: 'change'}],
        imageIds: [{required: true, message: '请添加企业主页图片', trigger: 'change'}],
      },
      props: {
        emitPath:false,
        expandTrigger: 'hover',
        value: 'value',
        label: 'label'
      },
      system: {
        emitPath:false,
        multiple: true,
        expandTrigger: 'hover',
        value: 'id',
        label: 'name'
      }
    }
  },
  created() {
    this.getIndustryList();
    this.getCity();
    this.getSystemList();
  },

   methods:{
    //获取行业类型
     async getIndustryList() {
       this.industryList = await this.$http('caseLibraryService.getIndustryList')
     },

     //新建客户
     addCustomer(){
       this.$refs.busData.validate(async valid => {
         if (!valid) {
           return
         }
         this.$http('caseLibraryService.addCustomer', this.busData).then(() => {
           this.$fn.search();
           this.$fn.closeWindow();
           this.$message.success("提交成功");
         })
       })
     },
     //系统现状数据
     async getSystemList(){
       this.systemList = await this.$http('crmDsService.getCrmSoftwareTree')
     },
     //根据网址获取天眼查数据
     async getTycUrlInfo(){
       let params = { company_name : this.busData.name}
       this.busData = await this.$http('tianYanChaNewService.getCompanyByName',params);
       this.busData.code = this.busData.city;
     },
     //获取城市数据
     async getCity(){
       this.catalogWithCity = await this.$http('caseLibraryService.getCatalogCity')
     },
     setImageId(ids){
       if(ids.length>0){
         this.busData.imageIds=ids
       }else{
         this.busData.imageIds=[]
       }
     },


  }

}



</script>

<style scoped>

.close {
  position: absolute;
  top: 10px;
  right: 0px;
  font-size: 18px;
  cursor: pointer;
}
</style>